module.exports = __webpack_public_path__ + "static/img/visionbg.ac68f91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/visionbg.jpg
// module id = NRcy
// module chunks = 1